import { ConfigSteps } from '@space-lib-events/toggleUnbanMemberCommunityModal'
import Icon from '@space-lib/components/icon'

import { CommunityTypeProductConsume, ComponentNames } from '@space-lib/datahub'
import { DataHubEntities, DataHubService } from '@space-lib/datahub/hotmartClub'
import { useDeviceInfo } from '@space-lib/hooks/useDeviceInfo'
import { UserInfoRole } from '@space-shell/common/services/user'
import { useUserInfoStore } from '@space-shell/core/store'
import useSendDataHubConsume from '@space-shell/modules/communities/hooks/useSendDataHubConsume/useSendDataHubConsume'
import ClickToAccessPrivacyAndAccessSchema from '@space-shell/modules/home/datahub/schemas/click/community/clickToAccessPrivacyAndAccessSchema'

import { ContainerMenuItem, Title } from './styles'

import { getConfigMenuEvents } from '../../../utils/events'
import type { MenuItemProps } from '../types'

const MenuItem = ({ item, selectedItem, setSelectedItem, community }: MenuItemProps) => {
  const { sendDataHubConsume } = useSendDataHubConsume()
  const deviceInfo = useDeviceInfo()
  const user = useUserInfoStore()

  const sendNewEventDatahub = () => {
    DataHubService.sendEvent({
      entity: DataHubEntities.Community,
      schema: new ClickToAccessPrivacyAndAccessSchema({
        communityId: community.id,
        communityType: CommunityTypeProductConsume[community.type],
        deviceInfo,
        userRole: user.role || UserInfoRole.VIEWER,
        componentName: ComponentNames.CONFIGURATION_MODAL
      })
    })
  }

  const handleClick = () => {
    if (selectedItem) return

    sendDataHubConsume(getConfigMenuEvents(item.step, community.id, community.name))

    if (item.step === ConfigSteps.ACCESS_AND_PRIVACY) {
      sendNewEventDatahub()
    }

    setSelectedItem(item.step)
  }

  return (
    <ContainerMenuItem
      className='_d-flex _align-items-center _mb-2 _rounded-lg _p-3'
      key={item.name}
      onClick={handleClick}
      $selectedItem={selectedItem}
      data-test='container-menu-item-community'>
      <Icon className='_text-gray-900' icon={item.icon} />
      <Title className='_text-2 _text-gray-900 _font-weight-light _mb-0 _ml-3 _mr-7'>
        {item.name}
      </Title>
    </ContainerMenuItem>
  )
}

export default MenuItem
